import type { HTMLAttributes } from 'react';
import { useTranslation } from 'react-i18next';
import styled, { css } from 'styled-components';
import { ColorNeutralGrey4, Spacing16, Spacing24 } from 'autogen/design-tokens/tokens';
import type { VariantLayoutType, VariantPickerListItem, VariantPickerModel } from 'autogen/swagger/all';
import { Edit } from 'autogen/translation-keys/trans-website-shared';
import { SplashRenderer } from 'components';
import InlineButton from 'components/generic/InlineButton';
import { HorizontalPriceModule } from 'components/generic/productPrice';
import SectionHeader from '../../VariantSection/SectionHeader';
import { containerMargin } from './shared/styles';

// #region Styles
const Wrapper = styled.div<{ $showBorder: boolean }>`
    display: flex;
    align-items: center;
    gap: ${Spacing24};

    ${({ $showBorder }) =>
        $showBorder &&
        css`
            border-bottom: 1px solid ${ColorNeutralGrey4};
            padding-top: ${Spacing16};
            padding-bottom: ${Spacing16};
        `}

    ${containerMargin};
`;

const StyledPriceModule = styled(HorizontalPriceModule)`
    white-space: nowrap;
    margin-left: auto;
`;

const StyledSplashRenderer = styled(SplashRenderer)`
    flex-shrink: 0;
`;

const EditButton = styled(InlineButton)`
    margin-left: auto;
`;
// #endregion Styles

type ListHeaderProps = {
    variant: VariantPickerListItem;
    layoutType: VariantLayoutType;
    price?: VariantPickerModel['price'];
    editCallback?: undefined | (() => void);
} & HTMLAttributes<HTMLDivElement>;

export default function ListHeader({ variant, layoutType, price, editCallback, ...restProps }: ListHeaderProps) {
    const { splash } = variant;
    const { t } = useTranslation();

    return (
        <Wrapper $showBorder={layoutType === 'Vertical'} {...restProps}>
            <SectionHeader {...variant} isVariantPicker />

            {splash && layoutType === 'Horizontal' && <StyledSplashRenderer splash={splash} />}

            {layoutType === 'Vertical' &&
                (editCallback ? (
                    <EditButton onClick={editCallback}>{t(Edit)}</EditButton>
                ) : (
                    price && <StyledPriceModule {...{ ...price, priceLabel: undefined }} size={14} />
                ))}
        </Wrapper>
    );
}
